import { useAuth } from "@/context/AuthContext";
import { Empty, ErrorBox, PageHead, Spinner, useFetch } from "@/components/common";
import { DigitalCard } from "@/components/DigitalCard";

export default function Cards() {
  const { user } = useAuth();
  const { data, error, loading } = useFetch("/customer/packages");
  return (
    <div className="space-y-6">
      <PageHead eyebrow="Wallet" title="My digital cards" sub="Your GIA CARE+ package cards" />
      {loading && <Spinner />}
      <ErrorBox error={error} />
      {data?.length === 0 && <Empty title="No cards yet" />}
      <div className="space-y-8">
        {data?.map((cp) => <DigitalCard key={cp.id} cp={cp} holder={user.full_name} />)}
      </div>
    </div>
  );
}
